module.exports = __webpack_public_path__ + "static/media/hp-login-banner-mobile-@1x.1632bc2a.jpg";